import MobileHeroCard from './MobileHeroCard';
import MobileHeroCardContainer from './MobileHeroCard.container';

export default MobileHeroCardContainer(MobileHeroCard);
